module.exports = __webpack_public_path__ + "static/media/IntegrationsActive.4d2569ac.svg";